import { inject, Injectable } from "@angular/core";
import { Actions, concatLatestFrom, createEffect, ofType } from "@ngrx/effects";
import { maintenanceScheduleActions } from "./maintenance-schedule.actions";
import { catchError, map, of, switchMap } from "rxjs";
import { MaintenanceCommonService } from "../../service/api/service/maintenance-common.service";
import { MaintenanceFfaService } from "../../service/api/service/maintenance-ffa.service";
import { GlobalExceptionHandlerService } from "../../service/api/service/global-exception-handler.service";
import { Store } from "@ngrx/store";
import { selectMaintenanceScheduleDate } from "./maintenance-schedule.selectors";
import { authActions } from "../auth/auth.actions";

@Injectable()
export class MaintenanceScheduleEffects {
    private actions$ = inject(Actions);
    private maintenanceCommonService = inject(MaintenanceCommonService);
    private maintenanceFfaService = inject(MaintenanceFfaService);
    private globalExceptionHandlerService = inject(GlobalExceptionHandlerService);
    private store = inject(Store);

    updateCheckMaintenanceSchedule$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(authActions.changeLoginDetails, authActions.changeLoginDetailsAndCompanyNoRedirect, maintenanceScheduleActions.updateCheckMaintenanceSchedule),
            switchMap(() => {
                return this.maintenanceCommonService.getMaintenance().pipe(
                    map(
                        maintenanceDate => maintenanceScheduleActions.setCheckMaintenanceSchedule({ maintenanceDate, successful: true })
                    ),
                    catchError((error) => {
                        this.globalExceptionHandlerService.handleGeneratedApiError(error);
                        return of(maintenanceScheduleActions.setCheckMaintenanceSchedule({ maintenanceDate: null, successful: false }));
                    })
                );
            })
        );
    });

    updateMaintenanceSchedule$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(maintenanceScheduleActions.updateMaintenanceSchedule),
            switchMap((action) => {
                return this.maintenanceFfaService.setMaintenance(action.maintenanceDate).pipe(
                    map(() => maintenanceScheduleActions.setCheckMaintenanceSchedule({ maintenanceDate: action.maintenanceDate, successful: true })),
                    catchError((error) => {
                        this.globalExceptionHandlerService.handleGeneratedApiError(error);
                        return of(maintenanceScheduleActions.setCheckMaintenanceSchedule({ maintenanceDate: null, successful: false }));
                    })
                );
            }),
        );
    });

    updateStopMaintenanceSchedule$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(maintenanceScheduleActions.updateStopMaintenanceSchedule),
            concatLatestFrom(() => [
                this.store.select(selectMaintenanceScheduleDate)
            ]),
            switchMap(([, activeDate]) => {
                return this.maintenanceFfaService.stopMaintenance().pipe(
                    map(() => maintenanceScheduleActions.setCheckMaintenanceSchedule({ maintenanceDate: null, successful: true })),
                    catchError((error) => {
                        this.globalExceptionHandlerService.handleGeneratedApiError(error);
                        return of(maintenanceScheduleActions.setCheckMaintenanceSchedule({ maintenanceDate: activeDate, successful: false }));
                    })
                );
            }),
        );
    });

}